<template>
  <div class="BaseButton">
    <button
      :type="type"
      @click="$emit('click')"
    >
      <slot />
    </button>
  </div>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    type: {
      type: String,
      default: 'button',
    },
  },
};
</script>

<style lang="scss" scoped>


.BaseButton {
  button {
    height: 40px;
    background-color: var(--color-primary);
    font-size: 1rem;
    color: white;
    border: none;
    border-radius: 12px;
    padding:  0.5rem 2rem;
    text-transform: uppercase;
    &:hover,
    &:focus {
      cursor: pointer;
    }
  }
  button:active{
    background-color: darken(hsl(209, 87%, 38%), 10%);
  }
}
</style>
